import { useCallback } from 'react';

type UseTaskCompletionParams = Readonly<{
	isCompleted: boolean;
	onCtaClick?: () => Promise<boolean>;
	onCheckboxChange?: () => Promise<void>;
}>;

type UseTaskCompletionReturn = Readonly<{
	isChecked: boolean;
	handleButtonClick: () => Promise<void>;
	handleCheckboxChange: (checked: boolean) => void;
}>;

export function useTaskCompletion({
	isCompleted,
	onCtaClick,
	onCheckboxChange,
}: UseTaskCompletionParams): UseTaskCompletionReturn {
	const isChecked = isCompleted;

	const handleButtonClick = useCallback(async () => {
		if (onCtaClick) {
			await onCtaClick();
		} else if (onCheckboxChange) {
			await onCheckboxChange();
		}
	}, [onCtaClick, onCheckboxChange]);

	const handleCheckboxChange = useCallback(
		(newValue: boolean) => {
			if (!newValue || !onCheckboxChange) return;
			void onCheckboxChange();
		},
		[onCheckboxChange],
	);

	return { isChecked, handleButtonClick, handleCheckboxChange };
}
